import React from "react";
import { LegalPageLayout } from "./LegalPageLayout";

const PrivacyPolicy = () => <LegalPageLayout slug="privacy-policy" />;

export default PrivacyPolicy;
